import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import defaultState from "./defaultState";

const customCheckerboardModule = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: { ...defaultState }
};

export default customCheckerboardModule;
